<template>
  <div class="poll-view">
    <!-- <div class="poll-view__title">
            New poll
        </div> -->
    <div class="poll-view__inner">
      <div class="poll-view__question">
        <input
          v-model="poll.question"
          type="text"
          placeholder="Your Question..."
        />
      </div>
      <div class="poll-view__answers">
        <div
          v-for="(answer, index) in poll.answers"
          :key="index"
          class="answer"
          :style="{ zIndex: poll.answers.length - index }"
        >
          <input
            :placeholder="'Answer ' + (index + 1)"
            @focus="createNewInput(index)"
            v-model="poll.answers[index].answer"
            type="text"
          />
          <span class="delete" @click="deleteInput(index)"
            ><svg-icon name="delete"
          /></span>
        </div>
      </div>
      <div class="poll-view__options">
        <!-- <label class="checkbox">Allow multiple votes
                    <input v-model="poll.multipleVotes" type="checkbox" checked="checked">
                    <span class="checkmark"></span>
                </label> -->
      </div>
      <div>
        <!-- poll-view__submit  -->
        <button @click="createPoll" class="post-submit">Create</button>
      </div>
      <div
        class="poll-view__info"
        :class="{ success: success === true, error: success === false }"
        v-if="success !== null"
      >
        <div v-if="success === true">Created</div>
        <div v-if="success === false">Error</div>
      </div>
    </div>
    <div v-if="demo" class="poll-view__footer">
      Made with &hearts; by <a href="https://updivision.com/">updivision.com</a>
    </div>
  </div>
</template>

<script>
import SvgIcon from "../SvgIcon.vue";
import { events } from "../../events";
import axios from "axios";

export default {
  components: { SvgIcon },
  name: "poll-creator",
  props: {
    savePollUrl: {
      type: String,
    },
    demo: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      files: null,
      tags: "null",
      poll: {
        question: "",
        answers: [
          // { answer: "10-20" },
          // { answer: "21-30" },
          // { answer: "31-40" },
          // { answer: "" }
        ],
        multipleVotes: false,
      },
      isValid: false,
      success: null,
    };
  },
  mounted() {
    if (this.poll.answers.length == 0) {
      this.poll.answers.push({ answer: "" });
    }
  },
  methods: {
    createNewInput(index) {
      if (this.poll.answers.length - 1 == index) {
        this.poll.answers.push({ answer: "" });
      }
    },
    deleteInput(index) {
      if (index > 0 || this.poll.answers.length > 1) {
        this.poll.answers.splice(index, 1);
      }
    },
    createPoll() {
      this.validate();
      let formData = new FormData();
      formData.append("description", "");
      formData.append("status", "Public");
      formData.append("answers", JSON.stringify(this.poll.answers));
      formData.append("question", this.poll.question);
      formData.append(
        "city",
        this.$store.state.userCurrentLocation.location.city
      );
      formData.append(
        "country_name",
        this.$store.state.userCurrentLocation.location.country_name
      );
      formData.append("os_type", this.$store.state.userCurrentLocation.os_type);
      formData.append(
        "device_type",
        this.$store.state.userCurrentLocation.device_type
      );
      formData.append("tags", this.tags);
      formData.append("files", this.files);

      axios
        .post(`${this.$store.state.endpoints.newFeed}`, formData, {
          headers: { Authorization: `Bearer ${this.$store.state.jwt}` },
        })
        .then((response) => {
          console.log();

          this.$store.state.feeds.unshift({
            city: response.data.data.city,
            country_name: response.data.data.country_name,
            created_at: response.data.data.created_at,
            description: response.data.data.description,
            device_type: response.data.data.device_type,
            id: response.data.data.id,
            os_type: response.data.data.os_type,
            status: response.data.data.status,
            updated_at: response.data.data.updated_at,
            user: this.$store.state.authuser,
            images: response.data.data.images,
            videos: response.data.data.videos,
            reacts: response.data.data.reacts,
            likes: response.data.data.likes,
            tags: response.data.data.tags,
            polls: response.data.data.polls,
            finalResults: response.data.data.finalResults,
          });
        });
      window.HyreadsEvents.emit(events.POLL_CREATED);
    },
    resetPoll() {
      this.poll.multipleVotes = false;
      this.poll.answers = [];
      this.poll.answers.push({ answer: "" });
      this.poll.answers.push({ answer: "" });
      this.poll.answers.push({ answer: "" });
      this.poll.answers.push({ answer: "" });
      this.poll.question = "";
      this.isValid = false;
    },
    validate() {
      this.poll.answers = this.poll.answers.filter((answer) => {
        if (answer.answer.length > 0) {
          return answer;
        }
      });
      var count = this.poll.answers.length;
      if (count > 1) {
        this.isValid = true;
      } else {
        this.isValid = false;
      }
    },
    alert(success) {
      this.success = success;
      setTimeout(() => {
        this.success = null;
      }, 3000);
    },
  },
};
</script>

<style lang="scss">
@import "./assets/vue-easy-polls.scss";
.post-submit {
  align-items: center;
  width: 100%;
  display: block;
  padding: 0.8rem 0;
  font-family: "Quicksand";
  font-size: 0.8rem;
  margin-bottom: 1rem;
  font-weight: 600;
  color: white;
  background: rgb(0, 110, 255);
  border: none;
  border-radius: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  -ms-border-radius: 5px;
  -o-border-radius: 5px;
  cursor: pointer;
}
</style>
